module.exports = __webpack_public_path__ + "static/media/email-image-2.c2adf1ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email-image-2.svg
// module id = 711
// module chunks = 0